import { privateApi } from "../api/axios";

export const getJuridicForms = async () => {
    try {
        const response = await privateApi.get("api/juridicforms");
        return response;
    } catch (error) {
        throw error;
    }
}